var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.benefitDetailData.iframeUrl)?_c('div',[_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.getBenefitIframeUrl(_vm.benefitDetailData),"frameborder":"0"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }